//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../AME/AME.SelectAMEBaseNode.js";
import "../no/SelectObject.js";
import "../no/Tooling.js";
let d=[[[0,"CreationMode",1,0],[0,"EoDataItemAttributeHolder",0,"AME.EODataItemAttributeHolder",0],[0,"InstanceDescription",1,0],[0,"InstanceName",1,0],[1,"SelectedBlock",0,"AME.SelectAMEBaseNode",0],[1,"SelectedEngObject",0,"AME.SelectAMEBaseNode",0],[0,"SelectedFBFromLibrary",0,"Tooling.SelectReuseLibraryItemBuilder",0],[0,"Type",1,0],[0,"TypeOfIDB",1,0]],[[["selBlock"],"UpdateSourceBlock",{},1,0],[["fileName"],"UpdateSourceBlockByName",{},1,0],[["symbolicName"],"SetSymbolicName",{},1,0]],[]];
SPLM.AME.InstanceDataBlockBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.InstanceDataBlockBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.InstanceDataBlockBuilder.ActionType = Object.freeze({
    "Global" : "Global", "Local" : "Local"});

SPLM.AME.InstanceDataBlockBuilder.CreateMode = Object.freeze({
    "Aspect" : "Aspect", "Library" : "Library"});

export default SPLM;